//Import Images
import athlete from "./img/Thumb.png";
import goodtimes from "./img/medkit1.png";
import theracer from "./img/travel3.png";
import athlete2 from "./img/pic-1.png";
import goodtimes2 from "./img/medkit2.png";
import theracer2 from "./img/travel2.png";

export const MovieState = () => {
  return [
    {
      title: "ApartmentCardinal",
      mainImg: athlete,
      secondaryImg: athlete2,
      url: "/work/the-athlete",
      awards: [
        {
          title: "Firebase Login/Sign up",
          description:
            "“Implemented Login/Sign in  & Register system using Firebase with fully responsive UI”",
        },
        {
          title: "Private Routes & more",
          description:
            "“Performed React-Router to  ensure the Private Routes & admin routes. Developed JWT system to ensure advance admin protection”",
        },
        {
          title: "Technology Used",
          description:
            "“React js, React-Router, Firebase Authentication, Material UI, Node js, MongoDB, Express, Heroku, Netlify”",
        },
      ],
    },
    {
      title: "Medkit",
      mainImg: goodtimes,
      url: "/work/good-times",
      secondaryImg: goodtimes2,
      awards: [
        {
          title: "Firebase Login/Sign up",
          description:
          "“Implemented Login/Sign in  & Register system using Firebase with fully responsive UI”",
        },
        {
          title: "Private Routes & more",
          description:
            "“Performed React-Router to  ensure the Private Routes & responsive UI”",
        },
        {
          title: "Technology Used",
          description:
            "“React js, Router, Firebase Authentication, Bootstrap, Node js Netlify”",
        },
      ],
    },
    {
      title: "Travel Cruise",
      mainImg: theracer,
      url: "/work/the-racer",
      secondaryImg: theracer2,
      awards: [
        {
          title: "Firebase Login/Sign up",
          description:
          "“Implemented Login/Sign in  & Register system using Firebase with fully responsive UI”",
        },
        {
          title: "Private Routes & more",
          description:
            "“Performed React-Router to  ensure the Private Routes”",
        },
        {
          title: "Technology Used",
          description:
            "“React js,React-Router, Firebase Authentication, Bootstrap, Node js, MongoDB, Express, Heroku”",
        },
      ],
    },
  ];
};
